import React from "react";
import { Link } from "react-router-dom";

// Enter & Vote · The Pawparazzi Red Carpet · Hall of Fame — `light` variant for the yellow Pup of the Month hero.
export default function RedCarpetNav({ active, light = false }) {
  const pill = (on) => `rounded-full px-4 py-2 text-sm font-display font-bold transition-colors ${on
    ? (light ? "bg-[#19324A] text-white" : "bg-[#FFD93D] text-[#19324A]")
    : (light ? "bg-white/80 text-[#19324A] hover:bg-white" : "bg-white/15 text-white hover:bg-white/25")}`;
  return (
    <nav className="flex flex-wrap gap-2" aria-label="Pup of the Month sections" data-testid="redcarpet-nav">
      <Link to="/pup-of-the-month" className={pill(active === "vote")} data-testid="rc-nav-vote">Enter &amp; Vote</Link>
      <Link to="/pawparazzi-red-carpet" className={pill(active === "redcarpet")} data-testid="rc-nav-redcarpet">The Pawparazzi Red Carpet</Link>
      <Link to="/pawparazzi-red-carpet#hall-of-fame" className={pill(active === "hof")} data-testid="rc-nav-hof">Hall of Fame</Link>
    </nav>
  );
}
